// This example shows you how to set up React Stripe.js and use Elements.
// Learn how to accept a payment using the official Stripe docs.
// https://www.stripe.com/docs/payments/integration-builder

import React from "react";

import "../css/global.css";

const Plan = ({
  plan,
  isActive,
  setChoosenPlan,
  setIsOpenUserModal,
  isOpenUserModal,
}) => {
  const planClassName = `plan-item ${isActive ? "active" : ""}
  }`;

  const onPlanClick = () => {
    if (isOpenUserModal) {
      return;
    }
    setChoosenPlan(isActive ? null : plan);
  };

  return (
    <div className={planClassName} onClick={onPlanClick}>
      <div>
        <span className="planTitle">{plan.title}</span>
        <span className="planDescription">{plan.description}</span>
      </div>
      <div>
        <div className="priceWrapper">
          <s className="fullPrice">{plan.fullPrice}€</s>
          <div className="price">{plan.price}€</div>
        </div>
        <form action="create-checkout-session.php" method="POST">
          <input type="hidden" name="payment_plan_id" value={plan.id} />
          <input type="hidden" name="amount" value={plan.price} />
          <input className="greenButton" type="submit" value="Πάρτε το" />
        </form>
      </div>
    </div>
  );
};

export default Plan;
